<!-- CheckupMethodologyWrapper.vue -->
<template>
  <div>
    <component
      :is="componentName"
      ref="methodology"
      :display-type="displayType"
      :portfolio="checkupStore.portfolio"
      :benchmark="checkupStore.benchmark"
      :optimized-portfolio="checkupStore.optimizedPortfolio"
    />
    <!-- :optimizedPortfolio="checkupStore.optimizedPortfolio" -->
  </div>
</template>


<script>
import { mapStores } from 'pinia';
import { useCheckupStore } from '@frontend/ui/stores/checkupStore';

import AssetClassMethodology from '@frontend/ui/features/checkup/components/methodologies/AssetClassMethodology.vue';
import AssetLocationMethodology from '@frontend/ui/features/checkup/components/methodologies/AssetLocationMethodology.vue';
import StyleCategoryMethodology from '@frontend/ui/features/checkup/components/methodologies/StyleCategoryMethodology.vue';
import SectorMethodology from '@frontend/ui/features/checkup/components/methodologies/SectorMethodology.vue';
import ReturnsMethodology from '@frontend/ui/features/checkup/components/methodologies/ReturnsMethodology.vue';
import RiskReturnsMethodology from '@frontend/ui/features/checkup/components/methodologies/RiskReturnsMethodology.vue';
import VolatilityMethodology from '@frontend/ui/features/checkup/components/methodologies/VolatilityMethodology.vue';
import FeesMethodology from '@frontend/ui/features/checkup/components/methodologies/FeesMethodology.vue';
import MarketCapMethodology from '@frontend/ui/features/checkup/components/methodologies/MarketCapMethodology.vue';
import ValuesMethodology from '@frontend/ui/features/checkup/components/methodologies/ValuesMethodology.vue';
import RiskMethodology from '@frontend/ui/features/checkup/components/methodologies/RiskMethodology.vue';
import ConcentrationBreakdownMethodology from '@frontend/ui/features/checkup/components/methodologies/ConcentrationBreakdownMethodology.vue';
import GeographyMethodology from '@frontend/ui/features/checkup/components/methodologies/GeographyMethodology.vue';
import FixedIncomeTypeMethodology from '@frontend/ui/features/checkup/components/methodologies/FixedIncomeTypeMethodology.vue';
import FixedIncomeDurationMethodology from '@frontend/ui/features/checkup/components/methodologies/FixedIncomeDurationMethodology.vue';
import StatisticsMethodology from '@frontend/ui/features/checkup/components/methodologies/StatisticsMethodology.vue';


export default {
  name: 'CheckupMethodologyWrapper',
  components: {
    AssetClassMethodology,
    AssetLocationMethodology,
    StyleCategoryMethodology,
    SectorMethodology,
    ReturnsMethodology,
    RiskReturnsMethodology,
    VolatilityMethodology,
    FeesMethodology,
    MarketCapMethodology,
    ValuesMethodology,
    RiskMethodology,
    ConcentrationBreakdownMethodology,
    GeographyMethodology,
    FixedIncomeTypeMethodology,
    FixedIncomeDurationMethodology,
    StatisticsMethodology,
  },
  props: ['componentName', 'displayType'],
  data() {
    return { /* Local variables */ };
  },
  computed: { /*
    Creates a new property
    Updates when any dependant property changes */
    ...mapStores(useCheckupStore),
  },
  watch: { /*
    Watches an existing property
    Only runs when the watched property changes */
  },
  mounted() {
    const textContent = this.$refs.methodology.$el.textContent;
    if (this.displayType && textContent) {
      const methodologyText = { [this.displayType]: textContent };
      this.checkupStore.setMethodologyData(this.componentName, methodologyText);
    }
  },
  methods: {},
};
</script>


<style scoped>

</style>
